<template>
  <div class="new-module">
    <add-or-update />
  </div>
</template>
<script>
import AddOrUpdate from "./_partial";
export default {
  components: {
    AddOrUpdate,
  },
};
</script>
